import { kStyles } from 'GlobalStyles';

const styles: kStyles = {
	table: {
		marginTop: 16,
	},
};

export default styles;
